export default {"src":"/_next/static/media/fr.451a45b2.svg","height":32,"width":33,"blurWidth":0,"blurHeight":0};